import {FC} from 'react'

type Props = {
  approvalStatus?: 'Pending' | 'Approved' | 'Rejected'
}

const ApprovalStatusCell: FC<Props> = ({approvalStatus}) => {
  const getStatusBadge = () => {
    switch (approvalStatus) {
      case 'Pending':
        return <span className='badge badge-light-warning'>⏳ Pending</span>
      case 'Approved':
        return <span className='badge badge-light-success'>✓ Approved</span>
      case 'Rejected':
        return <span className='badge badge-light-danger'>✗ Rejected</span>
      default:
        return <span className='badge badge-light-secondary'>-</span>
    }
  }

  return <div className='fw-bold'>{getStatusBadge()}</div>
}

export {ApprovalStatusCell}

